import { HTMLAttributes } from 'react'
import styled from '@emotion/styled'
import { AccountIcon } from 'shop/assets/icons'
import { useLocation, useNavigate } from 'react-router-dom'

type StyledHTMLElement = React.DetailedHTMLProps<
  HTMLAttributes<HTMLElement>,
  HTMLElement
> & {
  withIconBorder?: boolean
  inverted?: boolean
}

type Props = {
  inverted?: boolean
}

const AccountMenu = ({ inverted }: Props) => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleMenuClick = () => {
    navigate('/account', { state: { from: location.pathname } })
  }

  return (
    <AccountMenuContainer id='account-container'>
      <IconContainer {...{ inverted }} onClick={handleMenuClick}>
        <AccountIcon height='18px' width='18px' />
      </IconContainer>
    </AccountMenuContainer>
  )
}

const AccountMenuContainer = styled.div<StyledHTMLElement>(() => ({
  alignSelf: 'baseline'
}))

const IconContainer = styled.button<StyledHTMLElement>(
  ({ theme, inverted }) => {
    const invertedStyles = {
      backgroundColor: '#F5F5F5',

      '&:hover': {
        backgroundColor: '#F0F0F0'
      },

      '&:active': {
        backgroundColor: '#D8D8D8'
      },

      '>svg': {
        fill: 'black',
        '>path': {
          fill: 'black'
        }
      }
    }

    const defaultStyles = {
      backgroundColor: theme.colors['primary'],

      '&:hover': {
        opacity: 0.9
      },

      '&:active': {
        opacity: 0.8
      }
    }

    return {
      height: '32px',
      width: '32px',
      border: 'none',
      borderRadius: theme.borderRadius,
      cursor: 'pointer',
      padding: '7px',
      WebkitTapHighlightColor: 'transparent',

      ...(inverted ? invertedStyles : defaultStyles)
    }
  }
)

export default AccountMenu
